export const CUSTOMER = 1;
export const BUSINESS = 2;

export default Object.freeze({
  CUSTOMER,
  BUSINESS
});
